import { render, staticRenderFns } from "./Informedisponible.vue?vue&type=template&id=39a71e72&"
import script from "./Informedisponible.vue?vue&type=script&lang=js&"
export * from "./Informedisponible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports